export const crmPages = [
  ["overview", "客户总览", "crm.overview.view"],
  ["my-customers", "我的客户", "crm.customer.my"],
  ["public-pool", "公海池", "crm.customer.public_pool"],
  ["registration", "电销工作台", "crm.customer.register"],
  ["follow-records", "跟进记录", "crm.customer.follow"],
  ["todo", "待办提醒", "todo.task.list"],
  ["signed", "签约客户", "crm.customer.signed"],
  ["lost", "流失客户", "crm.customer.lost"],
  ["analysis", "客户分析", "crm.customer.analysis"],
  ["rules", "规则设置", "crm.rule.manage"],
  ["approvals", "审批中心", "crm.approval.list"],
  ["invalid", "黑名单/无效客户", "crm.customer.invalid"],
  ["calendar", "回访日历", "crm.calendar.view"],
  ["workbench", "销售工作台", "crm.workbench.view"],
  ["logs", "操作日志", "crm.log.list"],
].map(([slug, title, permission]) => ({
  slug,
  path: `/crm/${slug}`,
  title,
  permission,
  component: () => import(`../views/pages/crm/${slug === "my-customers" ? "myCustomers" : slug === "public-pool" ? "publicPool" : slug === "follow-records" ? "followRecords" : slug}.vue`),
}));
